import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import RegFont from "../RegFont";
import styles from "./style.module.css";
/*
 * Radio Button Component
 */
const FormRadio = ({ extraClassName, name, id, checked, onChange, value, label, boldLabel }) => {
    const onInputChange = (e) => {
        onChange(e.target.value, e.target.checked, e.target.name);
    };
    return (_jsx("div", { className: `${extraClassName || ""} ${styles.form_toggle}`, children: _jsx("div", { children: _jsxs("label", { className: styles.container, htmlFor: id, children: [_jsx("input", { onChange: onInputChange, type: "radio", value: value, name: name, id: id, checked: checked }), _jsx("span", { className: styles.checkmark }), label && _jsx(RegFont, { fontWeight: boldLabel ? 400 : 300, children: label })] }) }) }));
};
export default FormRadio;
